import zhTW from "./zh-TW";

// Hong Kong locale uses the same Traditional Chinese translations as zh-TW.
// If future differences are needed, this file can override specific keys.
const zhHK = {
  ...zhTW,
};

export default zhHK;
